import { render, staticRenderFns } from "./LayoutThird.vue?vue&type=template&id=15c1715f"
import script from "./LayoutThird.vue?vue&type=script&lang=js"
export * from "./LayoutThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports